export type FormState = {
  currentStep: number;
  isLoading: boolean;
  error: string | null;
  isCompleted: boolean;
};

export type FormAction = 
  | { type: 'NEXT_STEP' }
  | { type: 'PREV_STEP' }
  | { type: 'SET_LOADING'; payload: boolean }
  | { type: 'SET_ERROR'; payload: string | null }
  | { type: 'SET_COMPLETED'; payload: boolean }
  | { type: 'RESET' };

export const initialFormState: FormState = {
  currentStep: 0,
  isLoading: false,
  error: null,
  isCompleted: false
}; 